import type {ReactElement} from 'react';
import {Button, IconPlacement, ButtonSize, ButtonType} from '@Components/button';
import {Icon} from '@Components/icon-v2/icon';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import {EditorViewport} from '@EmailMakerReact/email-maker-react.types';
import {openEmailMakerPreviewModal} from '@EmailMakerReact/lib/email-maker-preview-library';
import {I18N_PREVIEW_KEY, ICON_EYE} from './preview-button.types';
import type {PreviewButtonProps} from './preview-button.types';

export function PreviewButton({editorViewport, editor}: PreviewButtonProps): ReactElement | null {
  if (editorViewport === EditorViewport.MOBILE) {
    return null;
  }

  function handlePreviewClick(): void {
    if (editor) {
      openEmailMakerPreviewModal(editor);
    }
  }

  if (editorViewport === EditorViewport.TABLET) {
    return (
      <Icon
        icon={ICON_EYE}
        shape={IconShape.SQUARE}
        type={IconType.DARK_GHOST}
        size={IconSize.SIZE_ICON_20}
        ariaLabel={window.i18next.t(I18N_PREVIEW_KEY)}
        onClick={handlePreviewClick}
      />
    );
  }

  return (
    <Button type={ButtonType.TERTIARY} onDark size={ButtonSize.MEDIUM} text={window.i18next.t(I18N_PREVIEW_KEY)} icon={ICON_EYE} iconPlacement={IconPlacement.LEFT} onClick={handlePreviewClick} />
  );
}
